module.exports = __webpack_public_path__ + "static/img/tabela.d1304d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/laranja-zero/tabela.png
// module id = 18sX
// module chunks = 0